<template>
  <div v-show="s">
    <div class="mask" @click="close"></div>
    <div class="box">
      <i class="iconfont icon-cha close" v-if="showClose" @click="close"></i>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showClose: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      s: false
    }
  },
  methods: {
    close() {
      this.s = false
      this.$emit('close')
    },
    show() {
      this.s = true
      this.$emit('show')
    }
  }
}
</script>

<style scoped lang="stylus" ref="stylesheet/stylus">
  @import "~common/stylus/variable"
  .mask
    background rgba(0,0,0,.4)
    position fixed
    left 0
    right 0
    bottom 0
    top 0
    z-index 98
  .box
    z-index 99
    position fixed
    width 84%
    left 50%
    top 50%
    transform translate(-50%, -50%)
    background #fff
    border-radius 11px
    padding size(28) size(22)
    .close
      position absolute
      top size(28)
      right size(22)
      color #999
      font-size 20px
</style>


// WEBPACK FOOTER //
// src/components/base/ui/popup.vue